const orderByReducer = (state, action) => {
    switch (action.type) {
        case "SET_ORDER_BY":
            return {
                ...state,
                orderBy: action.payload
            };
        default:
            return state;
    }
};

export default orderByReducer;
